export default __webpack_public_path__ + "static/media/Hero7.9187e395.png";